import { render, staticRenderFns } from "./UserAutocomplete.vue?vue&type=template&id=10f8d272&scoped=true"
import script from "./UserAutocomplete.vue?vue&type=script&lang=js"
export * from "./UserAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./UserAutocomplete.vue?vue&type=style&index=0&id=10f8d272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8d272",
  null
  
)

export default component.exports